import { Field } from "./Field";
export class Select extends Field {
    constructor(field) {
        super(field);
        this.formSelect = this.field.find('.form-select');
        this.formSelect.on(['change', 'keyup', 'click'], (event, field) => {
            this.value = this.formSelect.val();
        });
    }
    loadData() {
        this.value = this.formSelect.val();
    }
}
